import React from 'react';
import Fundraise from './Fundraise';
import InvestorsChart from './InvestorsChart';
import TotalAskChart from './TotalAskChart';
import FundraisingChart from './FundraisingChart';

export default function Overview() {

    const dummyData = [
        {
            raised: 8000,
            target: 10000,
            percentage: 85,
            donors: "117K",
            daysLeft: 28,
            recentDonors: [
                "/assets/others/user1.svg",
                "/assets/others/user2.svg",
                "/assets/others/user3.svg",
                "/assets/others/user1.svg",
                "/assets/others/user2.svg",
                "/assets/others/user3.svg",
                "/assets/others/user4.svg"
            ],
            description: "Lorem ipsum dolor sit amet consectetur. Pharetra odio dictumst lacus ipsum..."
        },
        {
            raised: 5000,
            target: 12000,
            percentage: 42,
            donors: "95K",
            daysLeft: 15,
            recentDonors: [
                "/assets/others/user2.svg",
                "/assets/others/user3.svg",
                "/assets/others/user1.svg",
            ],
            description: "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae..."
        }
    ];

    return (
        <div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3'>
                <div>
                    <FundraisingChart/>
                </div>
                <div>
                    <InvestorsChart />
                </div>
                <div>
                    <TotalAskChart/>
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
                {dummyData.map((item, index) => {
                    const words = item.description.split(" ");
                    const limitedDescription = words.length > 18
                        ? words.slice(0, 18).join(" ") + " more..."
                        : item.description;
                    return (
                        <div key={index} style={{ fontFamily: "Lato" }}>
                            <div className='bg-[#191919]/50 px-7 py-10 rounded-2xl space-y-3'>
                                <div className='flex items-center justify-between'>
                                    <div>
                                        <h1 className='text-[#929292] text-sm 2xl:text-base'>Raised so far</h1>
                                        <p className='font-medium text-xl 2xl:text-2xl'>$ {item.raised.toFixed(2)} <span className='text-[#929292] text-sm 2xl:text-base ml-2'>{item.percentage}%</span></p>
                                    </div>
                                    <div>
                                        <h1 className='text-[#929292] text-sm 2xl:text-base'>Target</h1>
                                        <p className='font-medium text-xl 2xl:text-2xl'>$ {item.target.toFixed(2)}</p>
                                    </div>
                                </div>
                                <div className='bg-white rounded-full'>
                                    <div className='bg-[#EA5455] h-3 rounded-full' style={{ width: `${item.percentage}%` }}></div>
                                </div>
                                <div className='flex space-x-6 text-sm 2xl:text-base'>
                                    <div className='space-x-1'>
                                        <i className='fa-regular fa-user text-[#929292]'></i> <span>{item.donors}</span>
                                    </div>
                                    <div className='space-x-1'>
                                        <i className='fa-solid fa-clock text-[#929292]'></i> <span>{item.daysLeft} days left</span>
                                    </div>
                                </div>
                                <h1 className='text-[#929292] text-sm 2xl:text-base'>Recent Donors</h1>
                                <div className='border-b pb-3 flex gap-1 items-center'>
                                    {item.recentDonors.slice(0, 6).map((imgSrc, i) => (
                                        <img key={i} src={imgSrc} className='w-12' alt={`donor-${i}`} />
                                    ))}
                                </div>
                                <h1 className='text-lg 2xl:text-xl'>Description</h1>
                                <p className='text-[#929292] text-sm 2xl:text-base'>
                                    {limitedDescription} <span className='text-white cursor-pointer'>Read more</span>
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>

        </div>
    );
}

